import React from 'react';

const OopsComponent = (
  <h1>
    Oops! Something went wrong
  </h1>
);

export default OopsComponent;
